import { useEffect, useMemo, useRef } from "react";
import { useApp } from "@/context/AppContext";
import { parseAdSenseSlot } from "./adMarkup";

const GOOGLE_ADS_DELIVERY_ENABLED = false;

const SLOT_STYLES = {
  TOP_BANNER:
    "min-h-[90px] w-full flex items-center justify-center bg-card/40 border border-border rounded-xl my-4 p-2 overflow-hidden",
  AFTER_INPUT:
    "min-h-[100px] w-full flex items-center justify-center bg-card/40 border border-border/80 rounded-xl my-6 p-2 overflow-hidden",
  BEFORE_DOWNLOAD:
    "min-h-[75px] w-full flex items-center justify-center bg-primary/5 border border-primary/20 rounded-lg my-3 p-2 overflow-hidden",
  BETWEEN_CONTENT:
    "min-h-[200px] w-full flex items-center justify-center bg-card/50 border border-border rounded-xl my-8 p-4 overflow-hidden",
  FOOTER:
    "w-full min-h-[60px] bg-card/60 backdrop-blur-md border-t border-border p-2 flex items-center justify-center",
};

export default function AdSlot({ slotKey }) {
  const { getAd } = useApp();
  const ad = GOOGLE_ADS_DELIVERY_ENABLED ? getAd(slotKey) : null;
  const config = useMemo(() => parseAdSenseSlot(ad?.code), [ad?.code]);
  const lastPushedConfig = useRef(null);
  const configKey = config ? [config.client, config.slot, config.format, config.fullWidthResponsive, config.layout, config.layoutKey, config.style.display, config.style.width, config.style.height].join("|") : null;

  useEffect(() => {
    if (!ad?.enabled || !config || !configKey) {
      lastPushedConfig.current = null;
      return;
    }
    if (lastPushedConfig.current === configKey) return;
    try {
      const queue = window.adsbygoogle || (window.adsbygoogle = []);
      queue.push({});
      lastPushedConfig.current = configKey;
    } catch {
      // An unavailable or blocked ad provider must not break the page.
    }
  }, [ad?.enabled, config, configKey]);

  if (!GOOGLE_ADS_DELIVERY_ENABLED || !ad?.enabled || !config) return null;
  return (
    <div
      data-testid={`ad-slot-${slotKey.toLowerCase()}`}
      className={SLOT_STYLES[slotKey] || SLOT_STYLES.TOP_BANNER}
    >
      <ins
        key={configKey}
        className="adsbygoogle"
        style={config.style}
        data-ad-client={config.client}
        data-ad-slot={config.slot}
        data-ad-format={config.format}
        data-full-width-responsive={config.fullWidthResponsive}
        data-ad-layout={config.layout}
        data-ad-layout-key={config.layoutKey}
      />
    </div>
  );
}
